import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as DownloadSvg } from './assets/download.svg';

const DownloadIcon = React.forwardRef((args, ref) => <SvgIcon component={DownloadSvg} ref={ref} {...args} />);

export default DownloadIcon;
